import React from 'react';
import WorkoutButton from '../components/MyButton';
import './MilestoneScreen.css';
import Trophy from './trophy.png';
import Money from './money.png';
import Medal from './medal.png';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {resetNavigationToOverview} from '../navigation/NavigationActions';
import {colors} from '../styles/colors';

export const milestoneTypes = {
	day: 'day',
	month: 'month',
	payout: 'payout',
};

const screenConfigByType = {
	[milestoneTypes.day]: {
		desc: 'dayDesc',
		img: Medal,
	},
	[milestoneTypes.month]: {
		desc: 'monthDesc',
		img: Trophy,
	},
	[milestoneTypes.payout]: {
		desc: 'payoutDesc',
		img: Money,
	},
};

function MilestoneScreen({location: {state}, t, confirm, ...rest}) {
	if (!state || !state.type) {
		return null;
	}
	const config = screenConfigByType[state.type];
	if (!screenConfigByType[state.type]) {
		return null;
	}
	const {desc, img} = config;

	return (
		<div className='milestoneScreenWrapper noSelectAtAll'>
			<div className='milestoneContainer'>
				<h1 className='milestoneTitle'>{t('milestone:title')}</h1>
				<div className='milestoneImageContainer'>
					<img src={img}></img>
				</div>

				<p className='milestoneDescription'>{t(`milestone:${desc}`)}</p>
				<div className='milestoneCTA'>
					<WorkoutButton
						title={t('common:next')}
						variant='raised'
						onPressButton={confirm}
						style={{
							height: 35,
							marginTop: 12,
							zIndex: 80,
							backgroundColor: '#fff',
							color: colors.primaryColor,
						}}
					/>
				</div>
			</div>
		</div>
	);
}
const mapDispatchToProps = (dispatch) => {
	return {
		confirm: () => dispatch(resetNavigationToOverview()),
	};
};

export default connect(
	null,
	mapDispatchToProps
)(translate(['common', 'milestone'])(MilestoneScreen));



// WEBPACK FOOTER //
// ./src/milestone/MilestoneScreen.js